import { ROOM_STATUS } from 'app/typings/core/admin/rooms/enum/roomStatus';
import type { RoomResponse } from 'app/typings/core/admin/rooms/room';
import type { Room, RoomCategory } from 'app/typings/rooms';

export const mapRoomResponseToRoom = (
  response: RoomResponse | undefined,
  roomCategories: RoomCategory[] | undefined
): Room | undefined => {
  if (!response || !roomCategories) {
    return undefined;
  }

  return {
    hotelId: response.hotelId,
    categoryId: response.categoryId,
    categoryName:
      roomCategories.find((rc) => rc.id === response.categoryId)?.name || '',
    name: response.name || '',
    hasPRM: response.hasPrmAccess,
    area: response.area,
    beds: response.beds.map((bed) => ({
      ...bed,
      included: bed.isIncluded,
    })),
    featureIds: response.roomServices.map((service) => service.id),
    pictures: response.pictures.map((pic) => ({
      pictureId: pic.path,
      name: pic.name || '',
      size: pic.size ?? 0,
      dimensions: pic.dimensions,
      alt: pic.alt || '',
      id: pic.id,
      updatedAt: new Date().toISOString(),
    })),
    id: response.id,
    bookingcomId: response.bookingcomId,
    bookingcomName: response.bookingcomName,
    categoryRoomCount: response.categoryRoomCount,
    status: response.status,
    published: response.status === ROOM_STATUS.PUBLISHED,
  };
};
